<template>
  <van-pull-refresh
    v-model="isRefresh"
    :head-height="80"
    @refresh="onRefresh"
    :disabled="disabled"
  >
    <van-list
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      style="padding-bottom:60px"
    >
      <div
        class="itemInfo"
        v-for="(item, index) in list"
        :key="index"
        @click="toOrderDetail(item)"
      >
        <div class="infoTop">
          <img :src="item.expressCompanyLogoUrl" alt="" />
          <div class="express">{{ item.expressCompanyName }}</div>
          <div>{{ '服务网点寄件' }}</div>
        </div>
        <div class="infoMain">
          <div class="orderTime">
            {{
              item.orderStatus === 2
                ? '快递单号:' + item.expressCode
                : '订单号：' + item.orderId
            }}
            <span style="color:#a30015" @click.stop="copyText(item)"
              >&nbsp;复制</span
            >
          </div>
          <div class="orderTime">
            下单时间：{{ formatDate(item.createTime) }}
          </div>
          <div class="orderTime">寄件人手机号：{{ item.senderPhone }}</div>
          <div class="detail">
            <div>
              <div style="font-weight:700">{{ item.senderName }}</div>
              <div class="province">{{ item.senderCity }}</div>
            </div>
            <div class="detail-center">
              <img
                :src="
                  item.orderStatus == -1
                    ? require('@/../static/icon-arrow-cancel.svg')
                    : require('@/../static/icon-arrow-success.svg')
                "
                alt=""
              />
              <div
                :style="
                  item.orderStatus == 0 && item.payStatus != 2
                    ? 'color:#a30014;'
                    : ''
                "
              >
                {{ set_status(item) }}
              </div>
            </div>
            <div>
              <div style="font-weight:700">{{ item.receiverName }}</div>
              <div class="province">{{ item.receiverCity }}</div>
            </div>
          </div>
        </div>
        <div class="infoBottom">
          <van-button
            plain
            round
            color="#000"
            class="btn"
            @click.stop="goFastMail()"
            >再寄一单</van-button
          >
          <van-button
            plain
            round
            color="#000"
            class="btn"
            v-if="
              (item.orderStatus == 0 || item.orderStatus == 1) &&
                item.payStatus != 2
            "
            @click.stop="handleCancel(index)"
            >取消订单</van-button
          >
          <van-button
            plain
            round
            color="#000"
            class="btn"
            v-if="item.orderStatus == 2 || item.orderStatus == -1"
            @click.stop="handleDelete(item)"
            >删除</van-button
          >
          <!-- <van-button
            plain
            round
            color="#a30014"
            class="btn"
            v-if="item.payStatus == 1"
            @click.stop="handlePay(item)"
            >支付订单</van-button
          > -->
        </div>
      </div>
    </van-list>
    <div
      class="empty flex font-14"
      v-if="list.length === 0 && !this.$store.state.loadingShow"
    >
      暂无相关快递信息
    </div>

    <cancel-order
      ref="cancel"
      :orderInfo="list[this.selectOrder]"
      @refresh="onRefresh"
      @close="close"
    />
  </van-pull-refresh>
</template>
<script>
import cancelOrder from './cancelOrder'
import { Dialog } from 'vant'
export default {
  data() {
    return {
      height: 0,
      isRefresh: false,
      loading: false,
      finished: false,
      list: [],
      currentPage: 0,
      selectOrder: 0,
      searchKey: '',
      disabled: false
    }
  },
  props: {
    status: Number,
    cilentHeight: Number
  },
  components: {
    cancelOrder
  },
  mounted() {
    this.height = this.cilentHeight - 260 + 'px'
  },
  methods: {
    onLoad() {
      this.currentPage++
      console.log('load')
      this.getList()
    },
    onRefresh() {
      // this.$router.options.routes[1].meta.keepAlive = false
      this.currentPage = 1
      this.list = []
      console.log('refresh')
      this.getList()
    },
    handleSearch(form) {
      // this.searchKey = form
      this.onRefresh()
    },
    close() {
      this.disabled = false
    },
    getList() {
      let params = {
        pageNum: this.currentPage,
        pageSize: 10,
        orderStatus: this.status
      }
      this.$emit('getKey')
      if (this.searchKey) {
        params = Object.assign(params, { searchKey: this.searchKey })
      }
      // console.log(params)
      let data = this.$Base64.encode(JSON.stringify(params))
      this.$api
        .getUserOrderList(data)
        .then(res => {
          this.loading = false
          this.isRefresh = false
          if (res.code === 0) {
            this.list = this.list.concat(res.data.rows)
            if (
              res.data.rows.length === 0 ||
              this.list.length >= res.data.totalCount
            ) {
              this.finished = true // 全部数据加载完了
            } else {
              this.finished = false
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.isRefresh = false
          this.finished = true
        })
    },
    toOrderDetail(item) {
      // console.log(JSON.stringify(item))
      let params = {
        orderId: item.orderId
      }
      this.$router.push({ path: '/orderDetail', query: params })
    },
    handleCancel(index) {
      this.selectOrder = index
      // console.log(this.$refs)
      this.$refs.cancel.handleShow()
      this.disabled = true
    },
    handleDelete(item) {
      Dialog.confirm({
        title: '提示',
        message: '确认删除该订单？'
      })
        .then(() => {
          // on confirm
          let params = {
            orderId: item.orderId
          }
          this.$api.deleteOrder(params).then(res => {
            if (res.code === 0) {
              this.$notify({
                message: '删除成功',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.onRefresh()
                }
              })
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    set_status(item) {
      let msg = ''
      if (item.orderStatus === -1) {
        msg = '已取消'
      }
      if (item.orderStatus === 0 && item.payStatus === 0) {
        msg = '待投递'
      }
      if (item.orderStatus === 0 && item.payStatus === 1) {
        msg = '待支付'
      }
      if (item.orderStatus === 0 && item.payStatus === 2) {
        msg = '已支付'
      }
      if (item.orderStatus === 1 && item.payStatus === 2) {
        msg = '已支付'
      }
      if (item.orderStatus === 2) {
        msg = '已完成'
      }
      return msg
    },
    formatDate(time) {
      return this.$format(time)
    },
    goFastMail() {
      this.$store.commit('clearInfo')
      this.$router.push({ path: '/goFastMail' })
    },
    copyText(item) {
      let value = ''
      if (item.orderStatus === 2) {
        value = item.expressCode
      } else {
        value = item.orderId
      }
      var input = document.createElement('input')
      input.value = value
      input.setAttribute('readonly', 'readonly')
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      this.$toast({
        position: 'bottom',
        message: '复制成功'
      })
      document.body.removeChild(input)
    },
    handlePay(item) {
      this.$router.push({ name: 'pay', query: { orderId: item.orderId } })
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  overflow: hidden;
}
// .van-pull-refresh {
//   height: calc(100vh - 276px) !important;
//   overflow: auto !important;
// }
.empty {
  margin: 50px 0 100px;
}
.itemInfo {
  width: calc(100% - 20px);
  // height: 210px;
  background-color: #fff;
  margin: 15px 10px;
  .infoTop {
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - 20px);
    height: 50px;
    padding: 0 10px;
    border-bottom: 1px solid #ccc;
    img {
      width: 38px;
      height: 37px;
    }
    .express {
      flex: 1;
      margin-left: 10px;
    }
  }
  .infoMain {
    .orderTime {
      margin: 10px;
      font-size: 14px;
    }
    .detail {
      display: flex;
      justify-content: space-around;
      padding: 0 10%;
      border-bottom: 1px solid #ccc;
      > div {
        // flex-wrap: wrap;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 30%;
        height: 70px;
        // line-height: 70px;
        text-align: center;
        .province {
          font-size: 14px;
          color: #7f7f7f;
        }
        img {
          width: 100%;
        }
      }
    }
  }
  .infoBottom {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 50px;
    .btn {
      margin: 0 5px;
      width: 90px;
      height: 36px;
    }
  }
}
</style>
